import React, { useEffect, useState } from "react";
import { Button, Dialog, EditIcon, PlusIcon, SearchInput, TrashIcon } from "evergreen-ui";
import { message, Table, Card, Input, Select, Form } from "antd";
import { MDBBox, MDBCol, MDBRow } from "mdbreact";
import Firebase from "../../../Firebase/Firebase";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { invalidateDemoData, useListVals } from "../../../Firebase/databaseHooks";
import { getDatabase, ref, update } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import moment from "moment";
import TableActionMenu from "../../../Common/TableActionMenu";
import { isActiveUserStatus } from "../../../../constants/userStatus";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

const { TextArea } = Input;
const { Item } = Form;
var db = getDatabase(Firebase);
const auth = getAuth(Firebase);

const OrganizationsLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const [form] = Form.useForm();
	const columns = [
		{
			title: 'Organization',
			dataIndex: 'organisation',
			key: 'organisation',
			sorter: (a, b) => a.organisation && a.organisation.localeCompare(b.organisation),
		},
		{
			title: 'Country',
			dataIndex: 'country',
			key: 'country',
			sorter: (a, b) => a.country && a.country.localeCompare(b.country),
		},
		{
			title: 'Date Added',
			dataIndex: 'date',
			key: 'date',
			sorter: (a, b) => moment(a.date, "DD/MMM/YYYY").diff(moment(b.date, "DD/MMM/YYYY")),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	];

	const [orgsList, setOrgsList] = useState([]);
	const [dataArray, setDataArray] = useState([]);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/organisations"));
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));
	const [searchValue, setSearchValue] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [selectedOrg, setSelectedOrg] = useState(null);
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [userRole, setUserRole] = useState(null);

	useEffect(() => {
		onAuthStateChanged(auth, function (user) {
			if (user) {
				var use = userArray[userArray.findIndex(x => (user.uid) === x.id)] && userArray[userArray.findIndex(x => (user.uid) === x.id)];
				if (arrayIn) {
					var role = use && use.userRole;
					setUserRole(role);
					var tempArray = [];
					arrayIn.map((item, index) => {
						tempArray.push({
							key: index,
							organisation: item.name,
							id: item.id,
							country: countries[countries.findIndex(x => x.id === item.countryID)] &&
								countries[countries.findIndex(x => x.id === item.countryID)].countryName,
							date: moment(item.startDate).format("DD/MMM/YYYY"),
							action: (
								<TableActionMenu
									items={[
										canUpdate && {
											key: "edit",
											label: "Edit",
											onClick: () => {
												if (role === "LclOrgStaff" || role === "LclOrgLeader") {
													if (use.organisationID === item.orgID) {
														form.setFieldsValue({
															name: item.name,
															countryID: item.countryID,
															responsibleUserID: item.responsibleUserID,
															notes: item.notes,
															SFOrgID: item.SFOrgID
														});
														setSelectedOrg(item);
														setShowModal(true);
													} else {
														message.error("You don't have the credentials to edit this organisation");
													}
												} else {
													form.setFieldsValue({
														name: item.name,
														countryID: item.countryID,
														responsibleUserID: item.responsibleUserID,
														notes: item.notes,
														SFOrgID: item.SFOrgID
													});
													setSelectedOrg(item);
													setShowModal(true);
												}
											},
										},
										canDelete && {
											key: "delete",
											label: "Delete",
											danger: true,
											onClick: () => {
												if (confirm("Delete this organisation?")) {
													props.messageBack("organisations", "delete", item.id);
												}
											},
										},
									]}
								/>
							)
						})
					});
					setOrgsList([...tempArray]);
					setDataArray([...tempArray]);
				}
			}
		})
	}, [arrayIn, props, countries, userArray, form, canUpdate, canDelete]);

	const handleSearch = searchText => {
		const filteredEvents = dataArray?.filter(({ country, organisation }) => {
			country = country?.toLowerCase();
			organisation = organisation?.toLowerCase();
			return country?.includes(searchText) || organisation?.includes(searchText);
		});

		setOrgsList(filteredEvents);
	};

	const handleUpdate = (values) => {
		if (!canUpdate) {
			message.error("You do not have permission to update organisations.");
			return;
		}

		var object = {
			"name": values.name,
			"SFOrgID": values.SFOrgID,
			"notes": values.notes,
			"countryID": values.countryID,
			"responsibleUserID": values.responsibleUserID
		}

		Object.entries(object).forEach(([key, value]) => {
			if (value === undefined) {
				object[key] = "";
			}
		});
		update(ref(db, "talmidsdb/organisations/" + selectedOrg.id), object)
			.then(() => {
				invalidateDemoData([
					"talmidsdb/organisations",
					"talmidsdb/organisations/" + selectedOrg.id,
				]);
				FireFetch.addLog("organisations", selectedOrg.id, "Edit");
				message.success("Organization updated successfully");
				setShowModal(false);
				form.resetFields();
			})
			.catch((error) => {
				message.error("Unable to update Organization due to an error: " + error);
			})
	}

	return (
		<div className="font-Nunito">
			<Dialog
				isShown={showModal}
				title={"Edit Organization"}
				onCloseComplete={() => {
					setShowModal(false);
					form.resetFields();
				}}
				hasFooter={false}
			>
				<MDBBox>
					<MDBRow>
						<MDBCol className="px-4">
							<Form
								form={form}
								layout="vertical"
								onFinish={handleUpdate}
							>
								<Item
									name="name"
									label="Organization Name"
								>
									<Input placeholder="Enter organization name" />
								</Item>
								<Item
									name="SFOrgID"
									label="SFOrg ID"
								>
									<Input placeholder="Enter SFOrg ID" />
								</Item>
								<Item
									name="countryID"
									label="Country"
								>
									<Select
										placeholder="Select country"
										showSearch
										name="countryID"
										optionFilterProp="children"
										filterOption={filterSelectOption}
										filterSort={sortSelectOptions}
									>
										{countries.map((item, index) => (
											<Select.Option value={item.id} key={index}>{item.name}</Select.Option>
										))}
									</Select>
								</Item>
								<Item
									name="responsibleUserID"
									label="Responsible User"
								>
									<Select
										placeholder="Select responsible user"
										showSearch
										optionFilterProp="children"
										filterOption={filterSelectOption}
										filterSort={sortSelectOptions}
									>
										{userArray?.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
											<Select.Option value={item.id} key={index}>
												{item.firstname + " " + item.surname}
											</Select.Option>
										))}
									</Select>
								</Item>
								<Item
									name="notes"
									label="Notes"
								>
									<TextArea placeholder="Enter notes" />
								</Item>
								<Item>
									<Button type="primary" htmlType="submit" className="my-3">
										Update
									</Button>
								</Item>
							</Form>
						</MDBCol>
					</MDBRow>
				</MDBBox>
			</Dialog>
			<div className="d-flex flex-row align-items-center">
				<SearchInput placeholder="Filter organisations" onChange={e => handleSearch(e.target.value)} value={searchValue} />
				{canCreate && (
					<Button appearance="primary" className="ml-3 my-2" onClick={() => {
						props.messageBack("organisations", "create");
					}}>
						New Organisation <PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="ml-3 my-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Organisations",
						exportButtons: false,
						sheetname: "Organisations",
					}), orgsList);
				}}>
					Print
				</Button>
			</div>
			<Card className="d-flex flex-column">
				<div>
					<Table
						style={{ overflow: "auto" }}
						loading={loading}
						pagination={{
							defaultPageSize: 100,
							showSizeChanger: true,
							pageSizeOptions: ['100', '200', '300']
						}}
						dataSource={orgsList}
						columns={columns}
						id={"dataTable"}
					/>
				</div>
			</Card>
		</div>
	);
}

export default OrganizationsLayout;
